
import { useState, useEffect } from 'react';

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Oshawa, ON',
      rating: 5,
      text: 'OhmEx Electric did an amazing job upgrading our electrical panel. The team was professional, punctual, and cleaned up after themselves. Highly recommend their services!',
      service: 'Panel Upgrade'
    },
    {
      name: 'Mike Chen',
      location: 'Whitby, ON',
      rating: 5,
      text: 'Excellent EV charger installation! They explained everything clearly and the installation was completed quickly. Now I can charge my Tesla at home with no issues.',
      service: 'EV Charger Installation'
    },
    {
      name: 'Jennifer Smith',
      location: 'Ajax, ON',
      rating: 5,
      text: 'The potlight installation transformed our living room completely. The lighting is perfect and the installation was done with minimal disruption. Great work!',
      service: 'Potlight Installation'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our <span className="text-yellow-600">Customers Say</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Read testimonials from satisfied customers throughout the GTA who trust OhmEx Electric for their electrical needs.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-lg p-8 md:p-12">
            <div className="text-center">
              <div className="flex justify-center mb-4">
                {[...Array(testimonials[currentSlide].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <blockquote className="text-lg md:text-xl text-gray-700 mb-6 italic">
                "{testimonials[currentSlide].text}"
              </blockquote>
              <div className="flex flex-col items-center">
                <h4 className="text-lg font-semibold text-gray-900">
                  {testimonials[currentSlide].name}
                </h4>
                <p className="text-gray-600">{testimonials[currentSlide].location}</p>
                <span className="text-sm text-yellow-600 font-medium mt-1">
                  {testimonials[currentSlide].service}
                </span>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-gray-600"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-gray-600"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-6 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === currentSlide ? 'bg-yellow-400' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
